// extracted by mini-css-extract-plugin
module.exports = {"root":"Article_root__qQoeU","wrapper":"Article_wrapper__sdnha","title":"Article_title__kJWpe"};